import { render, staticRenderFns } from "./CardSystem.vue?vue&type=template&id=80483d7a&scoped=true&"
import script from "./CardSystem.vue?vue&type=script&lang=js&"
export * from "./CardSystem.vue?vue&type=script&lang=js&"
import style0 from "./CardSystem.vue?vue&type=style&index=0&id=80483d7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80483d7a",
  null
  
)

export default component.exports